const PENDING_JOIN_KEY = 'pf_pending_join_intent';
const MAX_INTENT_AGE_MS = 1000 * 60 * 60 * 24 * 7; // 7 days

export function setPendingJoinIntent({ activityId, path }) {
  if (!activityId || !path || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(
      PENDING_JOIN_KEY,
      JSON.stringify({
        activityId: String(activityId),
        path: String(path),
        createdAt: Date.now(),
      })
    );
  } catch {
    // ignore storage errors
  }
}

export function readPendingJoinIntent() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(PENDING_JOIN_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.activityId || !parsed?.path) {
      clearPendingJoinIntent();
      return null;
    }
    const createdAt = Number(parsed.createdAt) || 0;
    if (!createdAt || Date.now() - createdAt > MAX_INTENT_AGE_MS) {
      clearPendingJoinIntent();
      return null;
    }
    return parsed;
  } catch {
    clearPendingJoinIntent();
    return null;
  }
}

export function clearPendingJoinIntent() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(PENDING_JOIN_KEY);
  } catch {
    // ignore storage errors
  }
}
